import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_228: DocMigration = {
  maxSchemaVersion: "0.0.228",
  description: "Change names of footing and pier type.",
  apply(json: any) {
    if (json.settings) {
      for (const settingId in json.settings) {
        const setting = json.settings[settingId];
        if (setting.type === "COLUMN_CATALOG_SETTINGS") {
          for (const tableId in setting.columnTable) {
            const column = setting.columnTable[tableId];
            if (column.entityType === "COLUMN" && column.subType === undefined) {
              column.subType = "ARCHITECTURAL";
            }
          }
        }
      }
    }
    return json;
  },
};

export default migration_0_0_228;
